// src/index.tsx

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ─── Favicon ─────────────────────────────────────────────
import sparkMoonIcon from './components/layouts/images/sparkmoon2.png';

const faviconLink =
  (document.querySelector("link[rel*='icon']") as HTMLLinkElement) ??
  document.createElement('link');

faviconLink.type = 'image/png';
faviconLink.rel = 'icon';
faviconLink.href = sparkMoonIcon;

document.head.appendChild(faviconLink);

// ─── React root ──────────────────────────────────────────
const rootElement = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();